import keyMirror from 'react-utils/keyMirror';
// @ts-expect-error ts-migrate(7016) FIXME: Could not find a declaration file for module 'Emai... Remove this comment to see the full error message
import { LINK_TYPES } from 'EmailSignatureEditor/plugins/unsubscribe/UnsubscribeConstants';
export default keyMirror(Object.assign({
  NO_UNSUBSCRIBE_LINK: null
}, LINK_TYPES));